var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 315,
    height: 193,
    viewBox: "0 0 315 193",
    style: {
      enableBackground: "new 0 0 315 193"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n        .st0 { fill: none; stroke: #3D3D3D; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192,103V35 M192,103l-73,73v-32.7c0-9.5,3.8-18.6,10.5-25.3l0.4-0.4c6.5-6.5,10.1-15.2,10.1-24.3l0,0             c0-9.1,3.6-17.9,10.1-24.3L157,62c3.8-3.8,6-9.1,6-14.5l0,0c0-5.4,2.2-10.7,6-14.5l23-23v27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38,176h166l73-73h-85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M148.5,70H111l-73,73h81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38,143v33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.5,77h-11.9c-8.2,0-12.3,0-15.9,1.5c-3.7,1.5-6.6,4.4-12.3,10.2l-36,36c-4.4,4.4-6.5,6.5-5.8,8.4             c0.8,1.9,3.8,1.9,10,1.9H120"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.5,98h-7.9c-8.2,0-12.3,0-15.9,1.5c-3.7,1.5-6.6,4.4-12.3,10.2L78,135"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 127.5,
    cy: 107.5,
    rx: 5.5,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.9,43.1c-4.3,1.4-7,3.7-7,6.2c0,4.3,7.1,7.8,17,7.8c12.6,0,18-3.5,18-7.8c0-2.5-1.7-4.7-6-6.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M142.9,47.1c0,2.8-4.9,5-11,5s-11-2.2-11-5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M142.9,47.1v-2c0-13.2,0-19.8-4.1-23.9c-4.1-4.1-10.7-4.1-23.9-4.1h-8 M61.7,17.1h49.2 M120.9,47.1v-4                 c0-3.8,0-5.7-1.2-6.8c-1.2-1.2-3.1-1.2-6.8-1.2H61.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.4,26.1L116.4,26.1c6.6,0,9.9,0,12.1,1.8c0.4,0.3,0.8,0.7,1.1,1.1c1.8,2.2,1.8,5.5,1.8,12.1v1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.9,21.1l-5,5l5,5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M227.7,42.8c4.3,1.4,7,3.7,7,6.2c0,4.3-8.1,7.8-18,7.8c-9.9,0-18-3.5-18-7.8c0-2.5,2.7-4.7,7-6.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.7,46.7c0,2.8,4.9,5,11,5s11-2.2,11-5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.7,16.7h-8c-13.2,0-19.8,0-23.9,4.1c-4.1,4.1-4.1,10.7-4.1,23.9v2 M237.7,16.7H269 M269,34.7h-33.2                 c-3.8,0-5.7,0-6.8,1.2c-1.2,1.2-1.2,3.1-1.2,6.8v4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M232.2,25.7L232.2,25.7c-6.6,0-9.9,0-12.1,1.8c-0.4,0.3-0.8,0.7-1.1,1.1c-1.8,2.2-1.8,5.5-1.8,12.1v1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M228.7,20.7l5,5l-5,5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.c79d82832ef5ec14ab97c2d1eb2e1bab.svg";
export { ForwardRef as ReactComponent };